// Auto-update de l'app Android : verifie au demarrage si un nouveau build du
// frontend a ete publie sur le VPS et l'applique sans repasser par un APK.
// No-op complet sur le site web (Capacitor.isNativePlatform() === false).
import { Capacitor } from "@capacitor/core";
import { CapacitorUpdater } from "@capgo/capacitor-updater";
import { fetchAppVersion } from "./api";
import { APP_BUILD } from "../config/appBuild";

export async function checkForAppUpdate() {
  if (!Capacitor.isNativePlatform()) return;

  try {
    // A appeler a CHAQUE demarrage, meme sans mise a jour : confirme au
    // plugin que le bundle actuellement charge fonctionne, sinon il finit
    // par revenir en arriere tout seul en pensant que le chargement a echoue.
    await CapacitorUpdater.notifyAppReady();
  } catch (e) {
    // non bloquant
  }

  try {
    const { version, url, build } = await fetchAppVersion();
    if (!version || !url) return; // rien de publie cote serveur pour l'instant

    // GARDE-FOU ANTI-RETOUR (2026-07-31). Avant, on comparait deux hashs pour
    // simple INEGALITE : le plugin conserve son bundle OTA dans les donnees de
    // l'app, ce qui survit a la reinstallation d'un APK, et un APK tout neuf
    // se faisait donc RETROGRADER vers l'ancien bundle en ligne des le premier
    // lancement (constate en vrai). Un hash ne dit pas lequel est le plus
    // recent - il faut un numero qui croit.
    if (typeof build !== "number") {
      console.warn("version.json sans champ `build` : mise a jour ignoree.");
      return;
    }
    if (build <= APP_BUILD) return; // deja a jour, ou en ligne plus ancien

    const { bundle } = await CapacitorUpdater.current();
    if (bundle.version === version) return; // ce bundle exact tourne deja

    const next = await CapacitorUpdater.download({ url, version });
    await CapacitorUpdater.set({ id: next.id });
    // set() recharge l'app immediatement : rien apres cet appel ne s'execute.
  } catch (e) {
    // VPS injoignable, pas de reseau, etc. - ne doit jamais bloquer l'usage
    // normal de l'app, meme esprit que les replis prix/image/langue.
    console.warn("Verification de mise a jour de l'app echouee (non bloquant) :", e);
  }
}
